// source: pbtypes/gen/scan_planner/orbit_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.scan_planner.OrbitScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.OrbitScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.OrbitScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.OrbitScanRequest.displayName = 'proto.scan_planner.OrbitScanRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.OrbitScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.OrbitScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.OrbitScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.OrbitScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sidelap: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
numPhotosPerOrbit: jspb.Message.getFieldWithDefault(msg, 12, 0),
heightBegin: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
heightEnd: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
gimbalPitchBegin: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
gimbalPitchEnd: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
lookOutwards: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
useHelix: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.OrbitScanRequest}
 */
proto.scan_planner.OrbitScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.OrbitScanRequest;
  return proto.scan_planner.OrbitScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.OrbitScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.OrbitScanRequest}
 */
proto.scan_planner.OrbitScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSidelap(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumPhotosPerOrbit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightBegin(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightEnd(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalPitchBegin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalPitchEnd(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLookOutwards(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseHelix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.OrbitScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.OrbitScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.OrbitScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.OrbitScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSidelap();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getNumPhotosPerOrbit();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getHeightBegin();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getHeightEnd();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getGimbalPitchBegin();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getGimbalPitchEnd();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getLookOutwards();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getUseHelix();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional double sidelap = 10;
 * @return {number}
 */
proto.scan_planner.OrbitScanRequest.prototype.getSidelap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setSidelap = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional uint32 num_photos_per_orbit = 12;
 * @return {number}
 */
proto.scan_planner.OrbitScanRequest.prototype.getNumPhotosPerOrbit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setNumPhotosPerOrbit = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double height_begin = 3;
 * @return {number}
 */
proto.scan_planner.OrbitScanRequest.prototype.getHeightBegin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setHeightBegin = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double height_end = 4;
 * @return {number}
 */
proto.scan_planner.OrbitScanRequest.prototype.getHeightEnd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setHeightEnd = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double gimbal_pitch_begin = 5;
 * @return {number}
 */
proto.scan_planner.OrbitScanRequest.prototype.getGimbalPitchBegin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setGimbalPitchBegin = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double gimbal_pitch_end = 6;
 * @return {number}
 */
proto.scan_planner.OrbitScanRequest.prototype.getGimbalPitchEnd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setGimbalPitchEnd = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional bool look_outwards = 9;
 * @return {boolean}
 */
proto.scan_planner.OrbitScanRequest.prototype.getLookOutwards = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setLookOutwards = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool use_helix = 11;
 * @return {boolean}
 */
proto.scan_planner.OrbitScanRequest.prototype.getUseHelix = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.OrbitScanRequest} returns this
 */
proto.scan_planner.OrbitScanRequest.prototype.setUseHelix = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


goog.object.extend(exports, proto.scan_planner);
